import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import {
  $getSelection,
  $isRangeSelection,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
} from "lexical";
import { $createImageNode } from "./ImageNode";

export const INSERT_IMAGE_COMMAND = createCommand("INSERT_CONTRACT_IMAGE");

const ImagePlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      INSERT_IMAGE_COMMAND,
      (payload) => {
        const { src, alt } = payload || {};
        if (!src) return false;
        const selection = $getSelection();
        if ($isRangeSelection(selection)) {
          selection.insertNodes([$createImageNode(src, alt || "")]);
        }
        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
};

export default ImagePlugin;
